var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.612 5.786C16.931 5.786 18 6.855 18 8.173v7.44C18 16.93 16.931 18 15.612 18H8.173c-1.318 0-2.387-1.069-2.387-2.388V8.173c0-1.318 1.069-2.387 2.387-2.387h7.44zm0 1.47H8.173c-.507 0-.918.41-.918.917v7.44c0 .506.411.918.918.918h7.44c.506 0 .918-.412.918-.919V8.173c0-.507-.412-.918-.919-.918zM9.827 0c1.318 0 2.387 1.069 2.387 2.388v.826c0 .406-.329.735-.734.735-.406 0-.735-.329-.735-.735v-.826c0-.507-.411-.919-.918-.919h-7.44c-.506 0-.918.412-.918.919v7.439c0 .507.412.918.919.918h.826c.406 0 .735.329.735.735 0 .405-.329.734-.735.734h-.826C1.069 12.214 0 11.145 0 9.827v-7.44C0 1.07 1.069 0 2.388 0h7.439z",
    transform: "translate(-664 -330) translate(40 330) translate(624) translate(3 3)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.cfca2e62.svg";
export { ForwardRef as ReactComponent };